var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 1.25C1.52982 1.25 1.25 1.52982 1.25 1.875V6.875C1.25 7.22018 0.970178 7.5 0.625 7.5C0.279822 7.5 0 7.22018 0 6.875V1.875C0 0.839466 0.839466 0 1.875 0H6.875C7.22018 0 7.5 0.279822 7.5 0.625C7.5 0.970178 7.22018 1.25 6.875 1.25H1.875ZM12.5 0.625C12.5 0.279822 12.7798 0 13.125 0H18.125C19.1605 0 20 0.839466 20 1.875V6.875C20 7.22018 19.7202 7.5 19.375 7.5C19.0298 7.5 18.75 7.22018 18.75 6.875V1.875C18.75 1.52982 18.4702 1.25 18.125 1.25H13.125C12.7798 1.25 12.5 0.970178 12.5 0.625ZM0.625 12.5C0.970178 12.5 1.25 12.7798 1.25 13.125V18.125C1.25 18.4702 1.52982 18.75 1.875 18.75H6.875C7.22018 18.75 7.5 19.0298 7.5 19.375C7.5 19.7202 7.22018 20 6.875 20H1.875C0.839466 20 0 19.1605 0 18.125V13.125C0 12.7798 0.279822 12.5 0.625 12.5ZM19.375 12.5C19.7202 12.5 20 12.7798 20 13.125V18.125C20 19.1605 19.1605 20 18.125 20H13.125C12.7798 20 12.5 19.7202 12.5 19.375C12.5 19.0298 12.7798 18.75 13.125 18.75H18.125C18.4702 18.75 18.75 18.4702 18.75 18.125V13.125C18.75 12.7798 19.0298 12.5 19.375 12.5Z",
    fill: "#202123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterFullScreen);
export default __webpack_public_path__ + "static/media/enterFullScreen.f75fe82a3420fcffd85aceaece1ec411.svg";
export { ForwardRef as ReactComponent };